import { Loader2 } from "lucide-react";

export default function Loader({ size = 32, className = "" }) {
  return (
    <div className="flex items-center justify-center">
      <Loader2
        className={`animate-spin text-primary ${className}`}
        size={size}
      />
    </div>
  );
}
